import { ReactChild } from 'react';
import { SkeletonBase } from '../../UIelements/Skeleton/styles';
import GraphSkeleton from '../../UIelements/Skeleton/GraphSkeleton';
import * as Styled from './styles';

interface EnergyConsumptionSkeletonProps {
  TitleBox: ReactChild
};

const EnergyConsumptionSkeleton = ({ TitleBox }: EnergyConsumptionSkeletonProps) => {
  return (
    <Styled.SkeletonContainer>
      {TitleBox}

      <Styled.InfoBarLayout>
        <Styled.InfoCardSkeleton />
        <Styled.InfoCardSkeleton />
        <Styled.InfoCardSkeleton />
        <Styled.InfoCardSkeleton />
        <Styled.InfoCardSkeleton />
      </Styled.InfoBarLayout>

      <Styled.GraphAndControlsWrapper>
        <GraphSkeleton height='420px'/>
        
        <Styled.ControlsContainer>
          {Array.from({ length: 4 }).map((_, index) => (
            <Styled.RadioSkeleton key={index}>
              <SkeletonBase height="20px" width="20px" style={{ borderRadius: '50%' }} />
              <SkeletonBase height="16px" width="60px" />
            </Styled.RadioSkeleton>
          ))}
        </Styled.ControlsContainer>
      </Styled.GraphAndControlsWrapper>


    </Styled.SkeletonContainer>
  );
};

export default EnergyConsumptionSkeleton;